import gql from 'graphql-tag';
import { PREVIEW_TRANSACTION_FRAGMENT } from 'data/fragments/transaction';
import { WALLET_FRAGMENT } from 'data/fragments/wallet';

export const ADMIN_USER_FRAGMENT = gql`
    fragment AdminUserFragment on User {
        _id
        username
        createdAt
        emails {
            address
            verified
            bounced {
                createdAt
                reason
            }
        }
        getLastTransactions {
            ...PreviewTransactionFragment
        }
        lastSeenAt
        notificationPreferences {
            customRitualActivity
            dailyDelivery
            feedbacks
            newFeatures
            recommendations
            reminders
            ritualInvite
            siteActivity
            specialOffers
            startingRitual
            weeklySummary
        }
        organization {
            _id
            name
        }
        userGroupIds
        profile {
            firstname
            lastname
            fullname
            state
            phone
            imageUrl
        }
        permissions {
            totemId
            totem {
                fullname
            }
            userGroup
        }
        stripeCustomerId
        visitedSites {
            _id
            name
            createdAt
            visitedAt
        }
        defaultTruckColumnId
        defaultTruckColumn {
            _id
            name
            siteId
            siteName
        }
        wallet {
            ...WalletFragment
        }
    }
    ${WALLET_FRAGMENT}
    ${PREVIEW_TRANSACTION_FRAGMENT}
`;

export const LOGGED_IN_USER_FRAGMENT = gql`
    fragment LoggedInUserFragment on User {
        _id
        username
        profile {
            firstname
            imageUrl
            lastname
        }
        permissions {
            totemId
            userGroup
        }
    }
`;

export const USER_NOTIFICATION_PREFERENCES = gql`
    fragment NotificationPreferences on NotificationPreferences {
        customRitualActivity
        dailyDelivery
        feedbacks
        newFeatures
        recommendations
        reminders
        ritualInvite
        siteActivity
        specialOffers
        startingRitual
        weeklySummary
    }
`;
